export function useActions(node, actions) {
    if (!actions)
        return;
    const actionReturns = actions.map((actionEntry) => {
        const [action, params] = Array.isArray(actionEntry) ? actionEntry : [actionEntry];
        return action(node, params);
    });
    return {
        update(newActions) {
            if (!newActions || newActions.length !== actionReturns.length) {
                throw new Error('You must not change the length of an actions array.');
            }
            newActions.forEach((actionEntry, i) => {
                const returnEntry = actionReturns[i];
                const [, params] = Array.isArray(actionEntry) ? actionEntry : [actionEntry];
                returnEntry?.update?.(params);
            });
        },
        destroy() {
            actionReturns.forEach((returnEntry) => {
                returnEntry?.destroy?.();
            });
        },
    };
}
